
import React from "react";

/**
 * Gestraffte persönliche Geschichte – 
 * Kostolany-Zitat als Leitmotiv, Burnout-Narrativ kompakt,
 * ohne Redundanz zur Hero-Story-Sektion
 */
const QuotePersonalSection = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container max-w-3xl mx-auto px-4">
        <div className="text-center mb-12">
          <blockquote className="text-xl md:text-2xl font-medium text-foreground/80 italic">
            „Nicht reich muss man sein, sondern unabhängig."
            <footer className="mt-3 text-sm text-muted-foreground font-normal not-italic">
              André Kostolany
            </footer>
          </blockquote>
        </div>
        
        <div className="prose prose-lg mx-auto text-muted-foreground max-w-none">
          <p>
            André Kostolanys Bücher haben mich fasziniert: mit Geld arbeiten und mit Menschen. 
            Meine Chefs erkannten meine strategischen, analytischen Fähigkeiten und vertrauten mir die 
            Abteilungsleitung Investmentfonds an. Menschen suchten meinen Rat, weil sie sahen, was ich konnte: 
            hinschauen, hinhören, Zusammenhänge erkennen.
          </p>
          
          <p>
            Bei allem Hinschauen hatte ich allerdings eine Blickrichtung vergessen: den Blick auf mich selbst. 
            Dieser blinde Fleck führte in den Burnout. Der Weg aus der Krise war weit. Er hat mich zurück zur 
            Natur geführt, hat mir gezeigt, wie Logik und Emotion einander ergänzen, dass Geld und Gefühl 
            mehr gemeinsam haben als den Anfangsbuchstaben.
          </p>

          <p className="text-foreground font-medium">
            Heute begleite ich Unternehmer, Führungskräfte und Entscheider auf dem Weg in die von Kostolany 
            gepriesene Unabhängigkeit.
          </p>
        </div>
      </div>
    </section>
  );
};

export default QuotePersonalSection;
